<template>
  <i-dropdown
    @open="reset"
    :isOpen="item.showOptions"
    @update:isOpen="(o) => setFilterParamOptions({name: item.name, showOptions: o})"
  >
    <template v-slot:trigger="{toggle, attrs}">
      <i-chip
          @click="toggle"
          @close="() => disableFilterParam({name: item.name})"
          :filter="paramLabel"
          :noFilterLabel="LANG.all"
          v-bind="attrs">
          {{ item.label }}
      </i-chip>
    </template>

    <template v-slot:default="dropdown">
      <div class="dropdown-menu dropdown-body block" style="padding: 0;">
        <div class="pa2 mb0">
          <SearchText
            v-model="searchTerm"
            ref="searchInputRef"
            @submit="() => apply(dropdown)"
            :placeholder="item.placeholder" />
        </div>
        <div class="i-css-right button_container pa2 pt0">
          <button
            @click.prevent.stop="() => clear(dropdown)"
            @keydown.enter.stop="() => clear(dropdown)"
            :title="LANG.clear"
            class="btn i-button i-secondary-btn i-filter-clear" >{{ LANG.clear }}</button>
          <button
            @click="() => apply(dropdown)"
            @keydown.enter.stop="() => apply(dropdown)"
            :title="LANG.apply"
            class="btn i-button i-filter-update" >{{ LANG.apply }}</button>
        </div>
      </div>
    </template>
  </i-dropdown>
</template>

<script>
import { mapState } from 'vuex';
import { mapBrowserMutations } from '@/store';
import SearchText from '@/components/common/SearchText.vue';

export default {
  components: {
    SearchText,
  },
  props: {
    item: Object,
  },
  data() {
    return {
      searchTerm: '',
    };
  },
  methods: {
    ...mapBrowserMutations([
      'disableFilterParam',
      'setFilterParam',
      'setFilterParamOptions',
    ]),
    apply(dropdown) {
      this.setFilterParam({
        name: this.item.name,
        value: [this.searchTerm],
      });
      if (dropdown) {
        dropdown.close();
      }
    },
    clear(dropdown) {
      this.searchTerm = '';
      this.apply(dropdown);
    },
    reset() {
      const [filterParamValue] = this.item.value;
      this.searchTerm = filterParamValue;
      this.$refs.searchInputRef.focus();
    },
  },
  computed: {
    ...mapState(['LANG']),
    params() {
      return this.item.value;
    },
    paramLabel() {
      return this.params.join(',');
    },
  },
};
</script>

<style scoped lang="scss">
</style>
